import { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useBrandContext } from '../../../context/BrandContext';
import { useHeaderContext } from '../../../context/HeaderContext';
import '../creditExtract/CreditExtract.css';

// Detalhe de uma transferência de saldo entre carteiras. Tudo o que a tela mostra já veio na
// linha do extrato (valor, contraparte em "Transferência de/para Fulano", data e pedido), então
// ela não consulta a API: recebe a linha pelo state da navegação. Aberta direto pela URL, sem
// esse state, volta para o extrato.
const TransferExtract: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const brandContext = useBrandContext();
  const { setHeaderConfig } = useHeaderContext();
  const statement: any = location.state;

  const backNavigation = useCallback(() => {
    navigate(`/${brandContext.brandName}/extract`);
  }, [brandContext.brandName, navigate]);

  useEffect(() => {
    if (!statement?.statementTransfer) backNavigation();
  }, [statement, backNavigation]);

  useEffect(() => {
    setHeaderConfig({
      headerText:
        statement?.statementTransfer === 'in'
          ? 'Transferência recebida'
          : 'Transferência enviada',
      backNavigation: backNavigation,
    });
    return () => setHeaderConfig({});
  }, [backNavigation, setHeaderConfig, statement]);

  if (!statement?.statementTransfer) return null;

  return (
    <div className='credit-extract-container'>
      <span className='credit-extract-ammount'>
        {`${statement.statementTransfer === 'in' ? '+ ' : ''}${
          statement.statementValue
        }`}
      </span>
      <span className='credit-extract-payment-card'>
        {statement.statementSubtitle}
      </span>
      <span className='credit-extract-date-time'>
        {statement.statementDate}
      </span>
      <div className='credit-extract-spott-info-container'>
        <span className='credit-extract-spott-info-ltda'>
          {statement.statementTransfer === 'in'
            ? 'Saldo recebido de outra carteira Spott'
            : 'Saldo enviado para outra carteira Spott'}
        </span>
        <span className='credit-extract-spott-info-transaction'>
          Transação #{statement.statementUwhOrderId}
        </span>
      </div>
    </div>
  );
};

export default TransferExtract;
